import combineBenchlingReducers from 'util/combineBenchlingReducers';

import reduceExecuteRequestFlow, {ExecuteRequestFlowState} from './execution/reduceExecuteRequestFlow';

export interface RequestsUIState {
  executeRequestFlow: ExecuteRequestFlowState;
}

export default combineBenchlingReducers({
  executeRequestFlow: reduceExecuteRequestFlow,
});
